export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6272.dfc41ac9.jpg";